import { component } from 'picoapp';
import Player from '@vimeo/player';

export default component(async (node, ctx) => {
  /**
   * Data + elements
   */
  const videoElements = node.querySelectorAll('.js-videoElement');
  const vimeoElements = node.querySelectorAll('.js-vimeoElement');

  /**
   * Functions
   */
  const createVideoCursor = (element) => {
    const cursor = element.querySelector('.js-videoCursor');
    const play = cursor.querySelector('.js-play');
    const pause = cursor.querySelector('.js-pause');

    element.addEventListener('mousemove', (event) => {
      const { top, left } = element.getBoundingClientRect();

      cursor.style.top = `${event.clientY - (Math.max(top, 0))}px`;
      cursor.style.left = `${event.clientX - (Math.max(left, 0))}px`;
    });

    element.addEventListener('mouseenter', () => {
      cursor.classList.remove('lg:hidden');

    });

    element.addEventListener('mouseleave', () => {
      cursor.classList.add('lg:hidden');
    });

    return {
      play,
      pause,
    };
  };

  const initVideos = () => {
    videoElements.forEach((element) => {
      const video = element.querySelector('video');
      const thumbnail = document.querySelectorAll('.thumbnail--image');

      let isPlaying = false;
      const cursor = createVideoCursor(element);

      video.addEventListener('playing', () => {
        isPlaying = true;
      });

      video.addEventListener('pause', () => {
        isPlaying = false;
     
      });

      const play = () => {
        video.play();

        cursor.play.hidden = true;
        cursor.pause.hidden = false;

        thumbnail.forEach(el => {
          el.classList.add('hidden');
        });
        video.classList.remove('hidden');

      };

      const pause = () => {
        video.pause();

        cursor.play.hidden = false;
        cursor.pause.hidden = true;

        thumbnail.forEach(el => {
          el.classList.remove('hidden');
        });
        video.classList.add('hidden');
      };

      const toggle = () => {
        if (isPlaying) {
          pause();
        } else {
          play();
        }
      };

      element.addEventListener('click', toggle);

    });
  };

  const initVimeoElements = () => {
    vimeoElements.forEach((element) => {
      const iframe = element.querySelector('iframe');
      const player = new Player(iframe);

      const cursor = createVideoCursor(element);

      const play = () => {
        player.play();

        cursor.play.hidden = true;
        cursor.pause.hidden = false;
      };
      const pause = () => {
        player.pause();

        cursor.play.hidden = false;
        cursor.pause.hidden = true;
      };

      const toggle = async () => {
        const isPaused = await player.getPaused();

        if (isPaused) {
          play();
        } else {
          pause();
        }
      };

      element.addEventListener('click', toggle);

      ctx.on('window:resize', async () => {
        const isPaused = await player.getPaused();

        if (!isPaused) {
          pause();
        }
      });
    });
  };

  const init = () => {
    initVideos();
    initVimeoElements();
  };

  /**
   * Init
   */
  init();
});
